import script from "./InputTime.vue?vue&type=script&lang=js"
export * from "./InputTime.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__